const audioPlayerStyle = Object.freeze({
  fontStack: 'alt',
});

export default audioPlayerStyle;
